//#region IMPORT
import React, { useState } from 'react';
import { useAppNavigate } from '../../Hooks/back/useAppNavigate';
/** Services Import */
import Global from '../../Services/Common/Global';
import Commons from '../../Services/Common/Common';
/** Components Import */
import { Loading } from '../../Components/MUIs';
import { useDispatch } from 'react-redux';
import { showSnackbar } from '../../Reducer/SnackbarReducer';
import { useSelector } from 'react-redux';
import Certification from './Certification';
import MyPage from './MyPage';
//#endregion

function MyPageFunction() {
  //#region 변수
  const { userInfo, lanInfo } = useSelector((state) => state.BaseInfo);

  const { navigate } = useAppNavigate();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  // const [dialog, setDialog] = useState({
  //   open: false,
  //   title: '',
  //   content: null,
  //   type: '',
  // }); // 팝업 객체

  const [inputs, setInputs] = useState({
    currentPassword: '',
    password: '',
    passwordConfirm: '',
  });
  const [settingToggle, setSettingToggle] = useState(false);

  const [certificationInputs, setCertificationInputs] = useState({
    passwoard: '',
  });
  const [capsLockFlag, setCapsLockFlag] = useState(false);
  const [findDialog, setFindDialog] = useState(false);

  //#endregion
  //#region 조회
  // 비밀번호 확인
  const SearchLogic1 = async () => {
    setLoading(true);

    try {
      if (!certificationInputs.passwoard) {
        dispatch(
          showSnackbar({
            message:
              lanInfo.length > 0
                ? lanInfo.filter(
                    (f) => f.lanId === 'PleaseEnterYourPassword'
                  )[0].lanNm
                : '',
            type: 'warning',
          })
        );

        return false;
      } else {
        await Commons.Axios(
          'post',
          Global.base.useUrl + Global.urls.Account.CheckPassword,
          {
            value1: userInfo.userid, // ID
            value2: Commons.EncryptAES(certificationInputs.passwoard), // PW
          }
        ).then((result) => {
          let data = result.data;

          if (
            data.length > 0 &&
            data[0].ID === Commons.DecryptoAES(userInfo.userid)
          ) {
            setCertificationInputs({
              ...certificationInputs,
              passwoard: '',
            });
            navigate('/Profile', { state: data[0] });
          } else {
            dispatch(
              showSnackbar({
                message:
                  lanInfo.length > 0
                    ? lanInfo.filter(
                        (f) => f.lanId === 'ThePasswordIsDifferent'
                      )[0].lanNm // 비밀번호가 다릅니다.
                    : '',
                type: 'warning',
              })
            );
          }
        });
      }
    } catch (e) {
      console.log('Error: ', e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    } finally {
      setLoading(false);
    }
  };
  //#endregion
  //#region 저장
  // 비밀번호 변경
  const SaveLogic1 = async () => {
    setLoading(true);
    let passwordRegex = /^(?=.*[A-Za-z])(?=.*\d).{8,}$/;

    try {
      if (!inputs.currentPassword) {
        dispatch(
          showSnackbar({
            message:
              lanInfo.length > 0
                ? lanInfo.filter(
                    (f) => f.lanId === 'PleaseEnterYourCurrentPassword'
                  )[0].lanNm // 현재 비밀번호를 입력하세요.
                : '',
            type: 'warning',
          })
        );
      } else if (!inputs.password) {
        dispatch(
          showSnackbar({
            message:
              lanInfo.length > 0
                ? lanInfo.filter(
                    (f) => f.lanId === 'PleaseEnterYourPassword'
                  )[0].lanNm // 비밀번호를 입력하세요.
                : '',
            type: 'warning',
          })
        );
      } else if (!inputs.passwordConfirm) {
        dispatch(
          showSnackbar({
            message:
              lanInfo.length > 0
                ? lanInfo.filter(
                    (f) => f.lanId === 'PleaseEnterYourPasswordConfirm'
                  )[0].lanNm // 비밀번호 확인을 입력하세요.
                : '',
            type: 'warning',
          })
        );
      } else if (inputs.password !== inputs.passwordConfirm) {
        dispatch(
          showSnackbar({
            message:
              lanInfo.length > 0
                ? lanInfo.filter((f) => f.lanId === 'ThePasswordIsDifferent')[0]
                    .lanNm // 비밀번호가 다릅니다.
                : '',
            type: 'warning',
          })
        );
      } else if (!passwordRegex.test(inputs.password)) {
        dispatch(
          showSnackbar({
            message: '영문, 숫자 포함 8자 이상으로 입력 해주세요.',
            type: 'warning',
          })
        );

        return false;
      } else {
        await Commons.Axios(
          'post',
          Global.base.useUrl + Global.urls.Account.ChangePassword,
          {
            UserId: userInfo.userid,
            CurrentPassword: Commons.EncryptAES(inputs.currentPassword),
            NewPassword: Commons.EncryptAES(inputs.passwordConfirm),
          }
        ).then((result) => {
          let data = result.data;

          if (data && data.type === 'Ok') {
            dispatch(
              showSnackbar({
                message:
                  lanInfo.length > 0
                    ? lanInfo.filter((f) => f.lanId === 'ItHasBeenChanged')[0]
                        ?.lanNm
                    : '변경되었습니다.',
                type: 'success',
              })
            );
            setFindDialog(false);
          } else {
            throw new Error(data?.message || '변경에 실패했습니다.');
          }
        });
      }
    } catch (e) {
      console.log('Error: ', e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    } finally {
      setLoading(false);
    }
  };
  //#endregion
  //#region 삭제

  //#endregion
  //#region 나머지 함수

  const MovePage = async (_page, _state = '') => {
    setLoading(true);

    try {
      navigate(_page, { state: _state });
    } catch (e) {
      console.log('Error: ', e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    } finally {
      setLoading(false);
    }
  };

  // 로그아웃 함수 (서버 LogOut → ClearMemberFcmAsync, Account_ClearMemberFcm 호출)
  const LogoutLogic = async () => {
    try {
      const logoutParams = {
        id: userInfo.userid ?? userInfo.userId ?? '',
        coCd: Commons.EncryptAES(userInfo.coCd ?? ''),
        fcmToken: '0',
        deviceType: Commons.EncryptAES(Commons.DeviceCheck() ?? ''),
      };
      const response = await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Account.logout,
        logoutParams
      );
      const data = response?.data;
      if (!data || (data?.Result !== 'Success' && data?.result !== 'Success')) {
        dispatch(
          showSnackbar({
            message: data?.message ?? '로그아웃 처리에 실패했습니다.',
            type: 'warning',
          })
        );
        return false;
      }
      Commons.Storages('set', 'auth', { auth: false });
      navigate('/');
    } catch (e) {
      const message =
        e?.response?.data ??
        e?.message ??
        '로그아웃 처리 중 오류가 발생했습니다.';
      dispatch(showSnackbar({ message: String(message), type: 'error' }));
    }
  };

  const checkCapsLock = (e) => {
    let capsLock = e.getModifierState('CapsLock');
    setCapsLockFlag(capsLock);
  };
  //#endregion

  return (
    <div className="wrap">
      {settingToggle ? (
        <Certification
          setSettingToggle={setSettingToggle}
          userInfo={userInfo}
          lanInfo={lanInfo}
          certificationInputs={certificationInputs}
          setCertificationInputs={setCertificationInputs}
          SearchLogic1={SearchLogic1}
        />
      ) : (
        <MyPage
          setSettingToggle={setSettingToggle}
          userInfo={userInfo}
          lanInfo={lanInfo}
          inputs={inputs}
          setInputs={setInputs}
          SaveLogic1={SaveLogic1}
          LogoutLogic={LogoutLogic}
          MovePage={MovePage}
          capsLockFlag={capsLockFlag}
          setCapsLockFlag={setCapsLockFlag}
          checkCapsLock={checkCapsLock}
          setFindDialog={setFindDialog}
          findDialog={findDialog}
        />
      )}
      <Loading open={loading} />
    </div>
  );
}

export default MyPageFunction;
